import { useEffect, useState } from 'react'

import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { observer } from 'mobx-react-lite'

import { RoutingPaths } from 'app/routes/routes'

import { popularDirectionAviaStore } from 'widgets/avia'

import { getOrCreateAviaSearchId } from 'entities/ticket/lib/avia-search-id'
import findTicketFormStore from 'entities/ticket/models/find-ticket/find-ticket-store'
import { DifficultRoute } from 'entities/ticket/models/find-ticket/models'

import { IPopularRoutesAvia } from 'shared/api/avia/main-page'
import { DATE_FORMAT_LIST } from 'shared/constants/dateFormatList'
import { addDate, dateFormat } from 'shared/lib/dateFormat'
import { HeaderGoBack } from 'shared/ui/header-go-back'

import { CardPopular } from './components/card-popular'
import s from './styles.module.scss'

const PopularDirection = observer(() => {
  const { t } = useTranslation()

  const navigate = useNavigate()

  const [popularRoutes, setPopularRoutes] = useState<
    IPopularRoutesAvia[] | null
  >(null)

  const getPopularRoutes = async () => {
    const cachedRoutes = popularDirectionAviaStore.getPopularDirections()
    try {
      if (cachedRoutes) {
        setPopularRoutes(cachedRoutes)
      } else {
        const data = await popularDirectionAviaStore.fetchPopularDirections()
        data && setPopularRoutes(data)
      }
    } catch (error: unknown) {}
  }

  const useGoSearch = (data: IPopularRoutesAvia) => {
    const dateCurrent = addDate({
      count: 1,
      type: 'day',
    })

    const dataSearch: DifficultRoute = {
      to: {
        cityName: data?.arr?.city?.title,
        countryName: data?.arr?.country,
        cityIataCode: data?.arr?.airport?.code,
      },
      from: {
        cityName: data?.dep?.city?.title,
        countryName: data?.dep?.country,
        cityIataCode: data?.dep?.airport?.code,
      },
      date:
        data.date || dateFormat(dateCurrent, DATE_FORMAT_LIST.YEAR_FULL_DATE),
    }

    findTicketFormStore.onSelectRecommendation(dataSearch)
    getOrCreateAviaSearchId(findTicketFormStore.formFindTicket)

    navigate(RoutingPaths.avia.search.path())
  }

  useEffect(() => {
    getPopularRoutes()
  }, [])

  return (
    <div className={s.container}>
      <div className={s.header}>
        <HeaderGoBack
          title={t('popular_direction')}
          buttonWhite
        />
      </div>

      <div className="container">
        {popularRoutes?.map((item, index) => (
          <div
            className={s.card}
            key={index}
          >
            <CardPopular
              data={item}
              onClick={() => useGoSearch(item)}
            />
          </div>
        ))}
      </div>
    </div>
  )
})

export default PopularDirection
